(function ($, root, undefined) {
	
    $(function () {

        'use strict';

        switch (Shopify.currency.active) {
            case 'USD':
                Shopify.money_format = "${{amount}}";
                break;
            case 'EUR':
                Shopify.money_format = "€{{amount}}";
                break;
            default:
                Shopify.money_format = "{{amount}}";
                break;
        }

        var app = {
            init: function() {
                this.initMobileMenu();
                this.initFooter();
                this.initCarousel();
                this.initProductGallery();
                this.initCartQuantityUpdate();
                this.initProductForm();
                this.initProductTabs();
                this.initCollectionFilters();
            },
            initMobileMenu: function() {
                $('#mobile-nav-toggle').on('click', function() {
                    $('body').toggleClass('mobile-menu-visible');
                    return false;
                });
                var $mobile_nav = $('.mobile-nav');
                var $mobile_nav_level_2_content = $mobile_nav.find('.mobile-nav-level-2 .mobile-nav-level-content');
                var level2_visible_classname = 'mobile-nav--level-2-visible';
                $mobile_nav.find('.main-menu .main-menu-item--has-submenu .main-menu-link').on('click', function() {
                    var $sub_menu = $(this).next('.sub-menu');
                    if ($sub_menu.length) {
                        var $sub_menu_clone = $sub_menu.clone();
                        $mobile_nav_level_2_content.html($sub_menu_clone);
                        $mobile_nav.addClass(level2_visible_classname);
                        return false;
                    }                    
                });
                $mobile_nav.find('.mobile-nav-level-2 .back-level').on('click', function() {
                    $mobile_nav.removeClass(level2_visible_classname);
                    return false;
                });
            },
            initFooter: function() {
                $('.footer-nav-title').on('click', function() {
                    $(this).toggleClass('expanded');
                    return false;
                });
            },
            initCarousel: function() {
                $('#carousel-section-slider').slick({
                    arrows: false,
                    fade: true,
                    nextArrow: "<button class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><g fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/><path fill='currentColor' d='M16.06 10.94a1.5 1.5 0 0 1 0 2.12l-5.656 5.658a1.5 1.5 0 1 1-2.121-2.122L12.879 12 8.283 7.404a1.5 1.5 0 0 1 2.12-2.122l5.658 5.657Z'/></g></svg></button>",
                    prevArrow: "<button class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><g fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/><path fill='currentColor' d='M7.94 13.06a1.5 1.5 0 0 1 0-2.12l5.656-5.658a1.5 1.5 0 1 1 2.121 2.122L11.122 12l4.596 4.596a1.5 1.5 0 1 1-2.12 2.122L7.938 13.06Z'/></g></svg></button>",
                    autoplay: true,
                    autoplaySpeed: 5000,                 
                    speed: 1000,
                    dots: true,
                    mobileFirst: true,
                    responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                            arrows: true
                          }
                        }
                    ]             
                });                
            },
            initProductGallery: function() {
                var $gallery = $('#single-product-gallery');
                var showDots = false;
                var showArrows = true;
                var allowSwipe = true;
                if ($gallery.hasClass('single-product-gallery--bundle')) {
                    showDots = false;
                    var allowSwipe = false;
                }                                
                var options = {
                    arrows: false,
                    fade: true,
                    swipe: allowSwipe,
                    nextArrow: "<button class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><g fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/><path fill='currentColor' d='M16.06 10.94a1.5 1.5 0 0 1 0 2.12l-5.656 5.658a1.5 1.5 0 1 1-2.121-2.122L12.879 12 8.283 7.404a1.5 1.5 0 0 1 2.12-2.122l5.658 5.657Z'/></g></svg></button>",
                    prevArrow: "<button class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'><g fill='none' fill-rule='evenodd'><path d='M24 0v24H0V0h24ZM12.593 23.258l-.011.002-.071.035-.02.004-.014-.004-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113-.013.002-.185.093-.01.01-.003.011.018.43.005.012.008.007.201.093c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.004-.011.017-.43-.003-.012-.01-.01-.184-.092Z'/><path fill='currentColor' d='M7.94 13.06a1.5 1.5 0 0 1 0-2.12l5.656-5.658a1.5 1.5 0 1 1 2.121 2.122L11.122 12l4.596 4.596a1.5 1.5 0 1 1-2.12 2.122L7.938 13.06Z'/></g></svg></button>",
                    autoplay: false,
                    speed: 1000,
                    dots: showDots,
                    mobileFirst: true,
                    responsive: [
                        {
                          breakpoint: 1024,
                          settings: {
                            arrows: showArrows
                          }
                        }
                    ]                                       
                };                
                $gallery.slick(options); 
            },
            updateCartCounter: function(count) {
                $('.js-cart-items-count').text(count);
            },
            updateCartLineItem: function(id, final_line_price) {
                $('.js-cart-item-' + id).find('.js-cart-line-final-price').text(Shopify.formatMoney(final_line_price));
            },
            updateCartTotal: function(total_price) {
                $('.js-cart-total-price').text(Shopify.formatMoney(total_price));
            },
            initCartQuantityUpdate: function() {
                $('.js-cart-item-quantity-form').on('change', function(event) {
                    var quantity = $(this).find('input[name="quantity"]').val();
                    var key = $(this).find('input[name="key"]').val();
                    Shopify.changeItem(key, quantity, function (data) {
                        var updated_cart_item = null;
                        for (var i = 0; i < data.items.length; i++) {        
                            if (data.items[i].key == key) {
                                updated_cart_item = data.items[i];
                            }
                        }
                        if (updated_cart_item) {
                            app.updateCartLineItem(updated_cart_item.id, updated_cart_item.final_line_price);
                        }             
                        app.updateCartTotal(data.total_price);           
                        app.updateCartCounter(data.item_count);
                    });
                    return false;
                });
            },
            initCartItemRemove: function() {
                $('.js-cart-item-remove').on('click', function() {
                    var id = $(this).data('id');
                    Shopify.removeItem(id, function(data) {
                        app.updateCartTotal(data.total_price);           
                        app.updateCartCounter(data.item_count);
                    })
                    return false;
                });
            },
            initProductForm: function() {
                $('.single-product-form').on('submit', function() {
                    var $form = $(this);
                    var $form_button = $form.find('button');
                    var button_text = $form_button.data('default-text');
                    var form_id = $(this).attr('id');                                        
                    $form_button.text('Adding to cart...').attr('disabled', true);                    
                    Shopify.addItemFromForm(form_id, function(added_line_item_data) {
                        $form_button.html("Successfully added to cart").attr('disabled', false);
                        window.setTimeout(function() {
                            $form_button.html(button_text);
                        }, 3000);
                        Shopify.getCart(function(cart_data) {
                            app.updateCartCounter(cart_data.item_count);
                        });                        
                    });
                    return false;
                });       
            },
            initProductTabs: function() {
                $('.additional-info-tab-title').on('click', function() {
                    $(this).parent().toggleClass('expanded');
                    return false;
                });
            },
            initCollectionFilters: function() {
                $('#collection-page-filters-form input').on('change', function() {
                    $(this).closest('form').submit();
                    return false;
                });
                $('#toggle-filter-visibility').on('click', function() {
                    $(this).toggleClass('active');
                    $('.collection-page-body').toggleClass('has-filter');
                    return false;
                });
                $('#close-collection-page-filters').on('click', function() {
                    $('.collection-page-body').removeClass('has-filter');
                    $('#toggle-filter-visibility').removeClass('active');
                    return false;
                });
            }
        };        
    
        app.init();
  
    });
	    
})(jQuery, this);